import { getAndroidFlatSurfaceStyle } from '@/components/common/android-flat-surface';
import type { GlassViewProps } from 'expo-glass-effect';
import { View } from 'react-native';
import { useGlassAvailable } from '../../hooks/useGlassAvailable';
import { useTheme } from '../../hooks/useTheme';

/** Keeps UIKit glass in the same appearance as its React content. */
export function GlassView({
  glassEffectStyle = 'regular',
  isInteractive,
  tintColor,
  style,
  ...props
}: Omit<GlassViewProps, 'colorScheme'>) {
  const { isDark, theme } = useTheme();
  const isGlass = useGlassAvailable();

  if (isGlass) {
    // Only load the native module after the shared iOS capability check.
    const { GlassView: NativeGlassView } =
      // eslint-disable-next-line @typescript-eslint/no-require-imports -- native module must be guarded
      require('expo-glass-effect') as typeof import('expo-glass-effect');
    return (
      <NativeGlassView
        {...props}
        style={style}
        glassEffectStyle={glassEffectStyle}
        isInteractive={isInteractive}
        tintColor={tintColor}
        colorScheme={isDark ? 'dark' : 'light'}
      />
    );
  }

  return (
    <View {...props} style={[{ backgroundColor: theme.surfaceElevated }, style, getAndroidFlatSurfaceStyle(theme.surface)]} />
  );
}
